import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const Img = Loadable({
    loader: () => import(/* webpackChunkName: "Img" */ './img'),
    loading: () => <div />,
});
